import type { RouterConfig } from '@nuxt/schema';

export default {
  routes: (_routes) => [
    {
      name: 'home',
      path: '/',
      component: () => import('~/pages/Home.vue'),
    },
    {
      name: 'search',
      path: '/shop/search/:pathMatch(.*)*',
      component: () => import('~/pages/Search.vue'),
      props: (route) => ({
        keyword: route.query.keyword,
        pageType: 'search',
      }),
    },
    {
      name: 'featured',
      path: '/shop/featured/:featuredName/:pathMatch(.*)*',
      component: () => import('~/pages/Search.vue'),
      props: (route) => ({
        ...route.params,
        featuredName: route.params.featuredName,
        pageType: 'featured',
      }),
    },
    {
      name: 'buy',
      path: '/buy/:featuredName/:pathMatch(.*)*',
      component: () => import('~/pages/Search.vue'),
      props: (route) => ({
        ...route.params,
        featuredName: route.params.featuredName,
        pageType: 'buy',
      }),
    },
    {
      name: 'shopPlp',
      path: '/shop/:pathMatch(.*)*',
      component: () => import('~/pages/Browse.vue'),
      props: (route) => ({
        id: route.query.id,
      }),
    },
    {
      // Add a path-match route for 404 Page Not Found
      name: 'notfound',
      path: '/:pathMatch(.*)*',
      component: () => import('~/pages/PageNotFound.vue'),
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition;

    if (to.hash) {
      const el = to.hash === '#canvas' ? '#sortable-grid-scroll-anchor' : to.hash;
      return { el, behavior: 'smooth' };
    }

    const isSameUrl = to?.fullPath?.toLowerCase?.() === from?.fullPath?.toLowerCase?.();
    if (to.meta.isSameRoute || to.meta.noRefreshForSYS || from.fullPath === '/' || isSameUrl) return {};
  },
} satisfies RouterConfig;
